<h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
<mat-dialog-content class="modal-content">
  <form [formGroup]="formData" class="grid grid-cols-2 gap-4">
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Host</mat-label>
      <input type="text" placeholder="Host" aria-label="Host" matInput [formControl]="hostControl" readonly>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>User</mat-label>
      <input type="text" placeholder="User" aria-label="User" matInput [formControl]="userControl" readonly>
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Password</mat-label>
      <input [type]="hide ? 'password' : 'text'"  placeholder="Password" aria-label="Password" matInput [formControl]="passwordControl">
      <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" [attr.aria-label]="hide ? 'Show password' : 'Hide password'">
        <mat-icon>{{ hide ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSubmit()"class="justify-end" [disabled]="!formData.valid">Guardar</button>
</mat-dialog-actions>  